'use client'

import {useState} from 'react'
import RetreatDetailsContext from './RetreatDetailsContext'

export const productData = {current: {}}

export default function ({children, value}) {
	productData.current = value.locale
	const [isOpen, setIsOpen] = useState(false)

	return (
		<RetreatDetailsContext.Provider value={{...value, isOpen, setIsOpen}}>
			{children}
		</RetreatDetailsContext.Provider>
	)
}
